var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"3","y":"3","width":"10","height":"10","rx":"1","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }